import { z } from 'zod'
import { THEME_NAMES } from '@/constants/theme'

/**
 * Single source of truth for environment configuration.
 * `import.meta.env` is read ONLY here — every other module imports the frozen,
 * validated `env` object. Invalid config aborts boot loudly rather than failing
 * deep inside a network call at runtime.
 */
const envSchema = z.object({
  VITE_API_URL: z.string().min(1, 'VITE_API_URL is required'),
  VITE_WS_URL: z.string().min(1, 'VITE_WS_URL is required'),
  VITE_APP_NAME: z.string().default('TAP Platform'),
  VITE_DEFAULT_THEME: z.enum(THEME_NAMES).default('tap-dark'),
  // Deployment tenant id, sent as X-Tenant-ID on pre-auth requests (login,
  // forgot/reset password). tap-api resolves the tenant from this header before
  // a session exists; after auth it must match the user's own tenant.
  VITE_TENANT_ID: z.string().optional(),
})

const result = envSchema.safeParse(import.meta.env)

if (!result.success) {
  console.error('Invalid environment configuration:')
  console.error(result.error.flatten().fieldErrors)
  throw new Error('tap-ui cannot start — invalid environment. Check .env.example')
}

export const env = Object.freeze(result.data)
export type Env = typeof env
